import REQ from '../../../utils/REQ';
import { PageBase } from './base';

export const PageError = () => {
  return <PageBase req={REQ.ERROR} />;
};
